import { render, staticRenderFns } from "./psychologySchedule.vue?vue&type=template&id=7f8879e0&"
import script from "./psychologySchedule.vue?vue&type=script&lang=js&"
export * from "./psychologySchedule.vue?vue&type=script&lang=js&"
import style0 from "./psychologySchedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports